import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

// import Managerdashboard from '../Managerdashboard/Managerdashboard.jsx';
// import PendingApprovals from '../PendingApprovals/PendingApprovals.jsx';
// import Team from '../Team/Team.jsx';
// import Calender from '../Calender/Calender.jsx';
import Settings from '../Settings/Settings.jsx';
// import Adminempployee from '../Employee/Employee.jsx';
import Adminapprovals from '../Adminapprovals/Adminapprovals.jsx';
import Project from '../Projects/Project.jsx';
import Admindashboard from '../Dashboard/Dashboard.jsx';
import AuditLogs from '../Auditlogs/Auditlogs.jsx';
import Tickets from '../Ticket/Tickets.jsx';

import NotificationsIcon from "@mui/icons-material/Notifications";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SecurityIcon from "@mui/icons-material/Security";
import WorkspacePremiumTwoToneIcon from '@mui/icons-material/WorkspacePremiumTwoTone';
import LogoutIcon from '@mui/icons-material/Logout';
import PeopleIcon from '@mui/icons-material/People';
import { Approval } from "@mui/icons-material";

// Styled Components
const ManagerPortal = styled.div`
  width: 100%;
  background-color: #f9fafb;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(155, 72, 72, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
`;

const Header = styled.header`
  background-color: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 24px;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Logo = styled.div`
  width: 32px;
  height: 32px;
  background-color: #2563eb;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  span {
    color: white;
    font-weight: bold;
    font-size: 14px;
  }
`;

const PortalTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

const TeamIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background-color: #e0f2fe;
  border: 1px solid #0277bd;
  border-radius: 12px;
  font-size: 12px;
  color: #0277bd;
  font-weight: 500;
  
  svg {
    font-size: 14px !important;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const NotificationIcon = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #f3f4f6;
  }
`;

const BellIcon = styled(NotificationsIcon)`
  font-size: 24px !important;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: #374151;
  }
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 18px;
  height: 18px;
  background-color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: white;
  border: 2px solid white;
  z-index: 10;
  
  /* Hide badge if count is 0 */
  ${props => props.count === 0 && 'display: none;'}
`;

const UserInfo = styled.div`
  text-align: right;
`;

const UserName = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin: 0;
`;

const UserRole = styled.p`
  font-size: 12px;
  color: #6b7280;
  margin: 0;
`;

const UserAvatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 2px solid #e5e7eb;
  cursor: pointer;
  transition: border-color 0.2s ease;
  
  &:hover {
    border-color: #2563eb;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
  
  span {
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    background-color: #f3f4f6;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const LogoutButton = styled.button`
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    background: #dc2626;
  }
  
  &:active {
    background: #b91c1c;
  }
  
  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`;

const LoadingSpinner = styled.div`
  width: 12px;
  height: 12px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #2563eb;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LogoutIconStyled = styled(LogoutIcon)`
  font-size: 14px !important;
`;

const Navigation = styled.nav`
  background-color: white;
  border-right: 1px solid #e5e7eb;
  padding: 0 18px;
  width: 135px;             // ← fixed width matching .adash-sidebar
  height: 100vh;            // ← use 100vh not 100% (parent isn't full height)
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  @media (max-width: 768px) {
    z-index: auto; /* This removes the stacking priority */
    
  }
`;

const NavTabs = styled.div`
  display: grid;
  gap: 32px;
  margin-top: 24px;
`;

const NavTab = styled.button`
  padding: 16px 8px;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  align-items: left;

  color: ${props => props.active ? '#2563eb' : '#6b7280'};
  border-bottom: 2px solid ${props => props.active ? '#2563eb' : 'transparent'};
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    color: #374151;
    border-bottom-color: ${props => props.active ? '#2563eb' : '#d1d5db'};
  }
  
  ${props => props.active && `
    color: #2563eb;
    font-weight: 600;
  `}
`;

const TabBadge = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 16px;
  height: 16px;
  background-color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  span {
    color: white;
    font-size: 10px;
    font-weight: bold;
  }
  
  /* Hide badge if count is 0 */
  ${props => props.count === 0 && 'display: none;'}
`;

const ManageNavbar = ({ currentPage = "Dashboard" }) => {
//   const [activeTab, setActiveTab] = useState(currentPage);
  const [user, setUser] = useState(null);
  const [pendingCount, setPendingCount] = useState(0);
  const [teamInfo, setTeamInfo] = useState({
    teamSize: 0,
    canApproveLeaves: false,
    assignedTeamMembers: []
  });
  const [loading, setLoading] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const tabPathMap = {
    Dashboard:"/Admindashboard",
    Approval:"/Adminapprovals",
    Employee: "/Adminemployee",
    Attendance: "/Attendance",
    Project:'/Project',
    Settings: "/Settings",
    AuditLogs:'/Auditlogs',
    Holidays:'/Holidays',
    Tickets:'/Tickets',
    // Team: "/Team",
    // Calendar: "/Calender",
  };

  // Reverse map: path to tab name
  const pathToTabMap = {
    
    // "/Adminemployee": "Employee",
    "/Admindashboard": "Dashboard",
    "/Adminapprovals":"Approval",
    "/Adminemployee":"Employee",
    '/Project':'Project',
    "/Settings": "Settings",
    '/Auditlogs':"AuditLogs",
    '/Holidays':"Holidays",
    '/Attendance':"Attendance",
    '/Tickets':"Tickets"
    // "/Team": "Team",
    // "/Calender": "Calendar",
  };

  // Derive activeTab directly from URL — no useState, no flash
  const activeTab = pathToTabMap[location.pathname] || currentPage;

  // Get backend URL
  const getBackendUrl = () => {
    return process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000';
  };

  // Fetch user data and team information
  const fetchUserData = async () => {
    try {
      const backendUrl = getBackendUrl();
      const response = await fetch(`${backendUrl}/api/user`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const userData = await response.json();
        setUser(userData);
        
        // If user is a manager, fetch team information
        if (userData.role && ['Manager', 'HR', 'CEO', 'Superadmin'].includes(userData.role)) {
          await fetchTeamInfo();
        }
      } else {
        console.error('Failed to fetch user data');
        setUser(null);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      setUser(null);
    }
  };

  // NEW: Fetch team information for managers
  const fetchTeamInfo = async () => {
    try {
      const backendUrl = getBackendUrl();
      const response = await fetch(`${backendUrl}/api/manager/pending-team-approvals`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();
        setTeamInfo({
          teamSize: data.total_team_size || 0,
          canApproveLeaves: true,
          assignedTeamMembers: data.team_members || []
        });
      } else {
        console.warn('Failed to fetch team info');
        setTeamInfo({ teamSize: 0, canApproveLeaves: false, assignedTeamMembers: [] });
      }
    } catch (error) {
      console.error('Error fetching team info:', error);
      setTeamInfo({ teamSize: 0, canApproveLeaves: false, assignedTeamMembers: [] });
    }
  };

  // UPDATED: Fetch pending approvals count - Only for assigned team members
  const fetchPendingCount = async () => {
    try {
      const backendUrl = getBackendUrl();
      
      // Use the team-specific pending approvals endpoint
      const response = await fetch(`${backendUrl}/api/pending-approvals`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();
        // The API returns an array of pending requests assigned to this manager
        setPendingCount(Array.isArray(data) ? data.length : 0);
      } else {
        console.warn('Failed to fetch pending count');
        setPendingCount(0);
      }
    } catch (error) {
      console.error('Error fetching pending count:', error);
      setPendingCount(0);
    }
  };

  // Initialize data
  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchUserData(),
          fetchPendingCount()
        ]);
      } catch (error) {
        console.error('Error initializing navbar data:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, []);

  // Auto-refresh pending count every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      fetchPendingCount();
    }, 30000); // Refresh every 30 seconds

    return () => clearInterval(interval);
  }, []);

  // Get user initials for avatar fallback
  const getUserInitials = (name) => {
    if (!name || name === 'Loading...' || name === 'Logging out...') return 'M';
    return name.split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  // Handle navigation
  const handleNavigation = (tab) => {
    try {
      // Immediately update the active tab for instant visual feedback
      
      const path = tabPathMap[tab];
      if (path) {
        navigate(path, { replace: true });
      }
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  // Handle notification click - Navigate to team pending approvals
  const handleNotificationClick = () => {
    if (pendingCount > 0) {
      
    } else {
      // Show a tooltip or message indicating no pending requests
      console.log('No pending team requests');
    }
  };

  // Handle avatar click (could open profile menu)
  const handleAvatarClick = () => {
    // You can implement profile menu or profile page navigation here
    console.log('Avatar clicked - implement profile menu');
  };

  // Enhanced logout handler
  const handleLogout = async () => {
    if (isLoggingOut) return; // Prevent multiple logout attempts

    try {
      setIsLoggingOut(true);
      console.log('🚪 Manager logout initiated...');
      
      // Clear user state first
      setUser({
        ...user,
        name: 'Logging out...'
      });
      
      // Get backend URL for consistency
      const backendUrl = getBackendUrl();
      
      // Try to call the backend logout endpoint first
      try {
        const response = await fetch(`${backendUrl}/auth/logout`, {
          method: 'GET',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' }
        });
        
        console.log('📄 Backend logout response:', response.status);
        
        // Even if backend logout fails, continue with frontend cleanup
        if (!response.ok) {
          console.warn('⚠️ Backend logout failed, continuing with frontend cleanup');
        }
      } catch (fetchError) {
        console.warn('⚠️ Backend logout request failed:', fetchError.message);
        // Continue with frontend cleanup even if backend call fails
      }

      // Clear any frontend storage/cache
      try {
        // Clear localStorage if your app uses it
        if (typeof Storage !== "undefined" && localStorage) {
          localStorage.clear();
        }
        
        // Clear sessionStorage if your app uses it
        if (typeof Storage !== "undefined" && sessionStorage) {
          sessionStorage.clear();
        }
      } catch (storageError) {
        console.warn('⚠️ Error clearing storage:', storageError);
      }

      console.log('✅ Frontend cleanup completed');
      console.log('🏠 Redirecting to home page...');
      
      // Force navigation to home page with state replacement
      // This ensures the user is properly logged out on the frontend
      navigate('/', { 
        replace: true,
        state: { loggedOut: true }
      });
      
      // Additional cleanup - force page reload after navigation to ensure clean state
      setTimeout(() => {
        window.location.href = '/';
      }, 100);
      
    } catch (error) {
      console.error('❌ Error during logout:', error);
      
      // Even if logout fails, force redirect to home
      console.log('🏠 Fallback: Force redirecting to home page...');
      
      try {
        navigate('/', { replace: true });
        setTimeout(() => {
          window.location.href = '/';
        }, 100);
      } catch (navError) {
        console.error('❌ Navigation failed, using window.location');
        window.location.href = '/';
      }
    } finally {
      setIsLoggingOut(false);
    }
  };

  // Format role display
  const formatRoleDisplay = (role) => {
    const roleMapping = {
      'Superadmin': 'Super Administrator',
      'CEO': 'Chief Executive Officer', 
      'HR': 'Human Resources',
      'Manager': 'Team Manager',
      'Employee': 'Employee'
    };
    
    return roleMapping[role] || 'Team Manager';
  };

  return (
    <div className="manger-navbar" style={{display:'flex'}} >
    <ManagerPortal>
      <Navigation>
          <div className="Manager-nav-manurevalogo" style={{marginTop: '19px',  gap: '10px', display: 'flex',  justifyContent: 'center', alignItems: 'center'}} >  <img src="/Images/manureva-logo.png" alt="M" />  </div>
        <NavTabs>
          {Object.keys(tabPathMap).map((tab) => (
            <NavTab
              key={tab}
              onClick={() => handleNavigation(tab)}
              active={activeTab === tab}
              aria-current={activeTab === tab ? 'page' : undefined}
            >
              {tab}
              {tab === "Approvals" && (
                <TabBadge count={pendingCount} title={
                  pendingCount > 0 
                    ? `${pendingCount} pending request${pendingCount !== 1 ? 's' : ''} from your assigned team members`
                    : 'No pending requests from your team'
                }>
                  {pendingCount > 0 && <span>{pendingCount}</span>}
                </TabBadge>
              )}
            </NavTab>
          ))}
        </NavTabs>
      </Navigation>
    </ManagerPortal>
    </div>
  );
};

export default ManageNavbar;